import { Filter } from './query-parameters.class';
import { SortField } from './query-parameters.class';
export class QueryPagingParameters {
  filters?: Filter[];
  sortFields?: SortField[];
  maxResults: number;
  page: number;
}
